import { ProjectMember } from "domain/entities/project-member";
import { create } from "zustand";
import { devtools } from "zustand/middleware";


interface ProjectMemberUploadState {
  projectMembersUpload: ProjectMember[];
  setProjectMembersUpload: (newProjectMembers: ProjectMember[] | undefined) => void;
}

export const useProjectMemberUploadStore = create<ProjectMemberUploadState>()(
  devtools(
    (set) => ({
      projectMembersUpload: [],
      setProjectMembersUpload: (newProjectMembers) =>
        set(() => ({
          projectMembersUpload: newProjectMembers ? [...newProjectMembers] : [],
        })),
    }),
    { name: "ProjectMembersUploadedStore" }
  )
);
